import React, { useState, useEffect } from 'react';
import { useForm, Controller } from "react-hook-form";
import { Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom'
import { _reasonForReferralState as _storage, formOptions } from '../_states/_reasonForReferralState';
import { _beginformState as _beginformStorage } from '../_states/_beginformState';
import { Radio, RadioGroup, FormControlLabel, FormControl } from '@mui/material';
import { MultiSelect } from "react-multi-select-component";
import ErrorMessage from '../helpers/_ErrorMessage';
import { UploadFiles } from './_UploadFiles';
import { yupResolver } from '@hookform/resolvers/yup';
import { RemainingCharacters } from '../helpers/_RemainingCharacters';

function ReasonForReferral() {
	const { control, register, handleSubmit, formState: { errors }, trigger } = useForm({mode:"onTouched", resolver:yupResolver(formOptions)})
	const [_states, setStates] = useState({
		mainTypeSupport: _storage.getMainTypeSupport(),
		contactInformationAround: _storage.getContactInformationAround(),
		detailsOfDisabilities: _storage.getDetailsOfDisabilities(),
		riskToStaff: _storage.getRiskToStaff(),
		riskDetails: _storage.getRiskDetails(),
		whatWillHappenNext: _storage.getWhatWillHappenNext(),
		involvedOrganisationOrProfession: _storage.getInvolvedOrganisationOrProfession(),
		organisationDetails: _storage.getOrganisationDetails(),
		files: _storage.getFiles()
	});
	const [mainSupportType, setMainSupportType] = useState(_storage.getMainTypeSupport());
	// const { data: supportTypeData, loading: mainTypeLoading } = useGetData(config.getMainSupportTypesPath);

	//TO DO:Delete hardcoded list when API is available
	const supportTypeData = [
		{code:"121", description:'Communication/Sensory Needs'},
		{code:"122", description:'Carrying Out Personal Care'},
		{code:"123", description:'Mental Health and Wellbeing'},
		{code:"124", description:'Preparing and Eating Food and Drink'},
		{code:"125", description:'Managing Home and Money'},
		{code:"126", description:'Relationships With Family and Friends'},
		{code:"127", description:'Being Part of a Community (Leisure, Learning and Work)'},
		{code:"128", description:'Support as a Parent'},
		{code:"129", description:'Getting Around'},
		{code:"130", description:'Communication, Interaction and Behaviour'},
		{code:"131", description:'Keeping Safe'},
		{code:"132", description:'Carers\' Support Needs'},
	];

	// scroll to the top
	useEffect(() => {
		window.scrollTo(0, 0);
	}, [])

	const navigate = useNavigate();
	const onSubmit = event => {
		navigate('/submit');
	};

	return (
		<Form className="input-form" onSubmit={handleSubmit(onSubmit)}>
			<main id="main" className="sectionOne">
				<div className="container-fluid">
					<div className="row">
						<div className="col-md-8">
							<div className="tab-content" id="myTabContent">
								<div className="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
									<h2>Reason for referral</h2>
									<p>Please provide details of the person whom you feel has social care needs.</p>
									<p>All fields marked * are mandatory and need to be completed so we can get the best outcome.</p>

									<div className={errors.mainTypeSupport ? 'form-group form-group--error' : 'form-group'}>
										<label htmlFor="mainTypeSupport" id="mainTypeSupport-label" className="form-label">What is the main type of support they need?*</label>
										<p>You can choose more than one</p>
										<ErrorMessage id="mainTypeSupport" error={errors.mainTypeSupport}/>
										<div className="js--select" style={{ width: '50%', fontSize: '19' }}>
											<Controller name="mainTypeSupport" control={control}
												render={({ field: { value, onChange, ...field } }) => (
													<MultiSelect {...field} {...register('mainTypeSupport')}
														id="mainTypeSupport"
														name="mainTypeSupport"
														value={mainSupportType}
														valueRenderer={(value) => {
															if (value.length === 0)
																return <>Please select</>;
														}}
														labelledBy="mainTypeSupport-label"
														onChange={(e) => {
															onChange(e);
															setMainSupportType(e);
															_storage.setMainTypeSupport(e);
															// Manually trigger validation for mainTypeSupport to trigger the test function for checking the input length
															trigger("mainTypeSupport");
														}}
														options={supportTypeData.map((supportType) => {
															return { label: supportType.description, value: supportType.code }
														})}
														hasSelectAll={false}
													>
													</MultiSelect>
												)}
											/>
										</div>

									</div>

									<div className={errors.contactInformationAround ? 'form-group form-group--error' : 'form-group'}>
										<label htmlFor="contactInformationAround" className="form-label">Please provide more information around your contact today*</label>
										<p>Please provide more detail about each type of support, as selected above, to ensure we can provide the correct response</p>
										<ErrorMessage id="contactInformationAround" error={errors.contactInformationAround}/>
										<Controller name="contactInformationAround" control={control}
											render={({ field: { value, onChange, ...field } }) => (
												<textarea {...field} rows="4" type="text" id="contactInformationAround" name="contactInformationAround" value={_states.contactInformationAround}
													className={`form-control ${errors.contactInformationAround ? 'is-invalid' : ''}`}
													aria-invalid={errors.contactInformationAround ? "true" : "false"}
													aria-describedby={errors.contactInformationAround ? "contactInformationAround-error" : ""}
													{...register('contactInformationAround')} onChange={(e) => {
														onChange(e.target.value);
														_storage.setContactInformationAround(e.target.value);
														setStates({ ..._states, [e.target.name]: e.target.value })
													}}
												/>
											)}
										/>
										<p>You can enter up to 500 characters</p>
										<RemainingCharacters maxNoCharacters={500} inputValue={_states.contactInformationAround} />
									</div>

									<div className={errors.detailsOfDisabilities ? 'form-group form-group--error' : 'form-group'}>
										<label htmlFor="detailsOfDisabilities" className="form-label">Details of any disabilities and/or physical access needs of person being referred?*</label>
										<p>For example, the person has a physical disability and uses a wheelchair</p>
										<ErrorMessage id="detailsOfDisabilities" error={errors.detailsOfDisabilities}/>
										<Controller name="detailsOfDisabilities" control={control}
											render={({ field: { value, onChange, ...field } }) => (
												<textarea {...field} rows="4" type="text" id="detailsOfDisabilities" name="detailsOfDisabilities" value={_states.detailsOfDisabilities}
													className={`form-control ${errors.detailsOfDisabilities ? 'is-invalid' : ''}`}
													aria-invalid={errors.detailsOfDisabilities ? "true" : "false"}
													aria-describedby={errors.detailsOfDisabilities ? "detailsOfDisabilities-error" : ""}
													{...register('detailsOfDisabilities')} onChange={(e) => {
														onChange(e.target.value);
														_storage.setDetailsOfDisabilities(e.target.value);
														setStates({ ..._states, [e.target.name]: e.target.value })
													}}
												/>
											)}
										/>
										<p>You can enter up to 150 characters</p>
										<RemainingCharacters maxNoCharacters={150} inputValue={_states.detailsOfDisabilities} />
									</div>

									<div className={errors.riskToStaff ? 'form-group form-group--error' : 'form-group'}>
										<fieldset aria-describedby={errors.riskToStaff ? "riskToStaff-error" : ""}>
											<legend className="sr-only">Are there any risks to staff?</legend>
											<FormControl>
												<label htmlFor="riskToStaff" className="form-label">Are there any risks to staff?*</label>
												<p>For example, visits to the person will be in pairs</p>
												<ErrorMessage id="riskToStaff" error={errors.riskToStaff}/>
												<RadioGroup {...register('riskToStaff')} name="riskToStaff" id="riskToStaff" value={_states.riskToStaff}
													onChange={(e) => {
														setStates({ ..._states, [e.target.name]: e.target.value })
														_storage.setRiskToStaff(e.target.value);
													}}
												>
													<FormControlLabel {...register('riskToStaff')} value="yes" control={<Radio />} label="Yes" />
													<FormControlLabel {...register('riskToStaff')} value="no" control={<Radio />} label="No" />
													<FormControlLabel {...register('riskToStaff')} value="dontknow" control={<Radio />} label="Don't know" />
												</RadioGroup>
											</FormControl>

											{(_states.riskToStaff === "yes") && (
												<div className="panel panel-border-narrow js-hidden">
													<label htmlFor="riskDetails" className="form-label">If yes, please give details*</label>
													<ErrorMessage id="riskDetails" error={errors.riskDetails}/>
													<Controller name="riskDetails" control={control}
														render={({ field: { value, onChange, ...field } }) => (
															<textarea  {...field} rows="4" type="text" id="riskDetails" name="riskDetails" value={_states.riskDetails}
																className={`form-control ${errors.riskDetails ? 'is-invalid' : ''}`}
																aria-invalid={errors.riskDetails ? "true" : "false"}
																aria-describedby={errors.riskDetails ? "riskDetails-error" : ""}
																{...register('riskDetails')} onChange={(e) => {
																	onChange(e.target.value);
																	_storage.setRiskDetails(e.target.value);
																	setStates({ ..._states, [e.target.name]: e.target.value })
																}}
															/>
														)}
													/>
													<p>You can enter up to 150 characters</p>
													<RemainingCharacters maxNoCharacters={150} inputValue={_states.riskDetails} />
												</div>
											)}
										</fieldset>
									</div>

									<div className={errors.whatWillHappenNext ? 'form-group form-group--error' : 'form-group'}>
										<label htmlFor="whatWillHappenNext" className="form-label">What do you hope will happen next?</label>
										<ErrorMessage id="whatWillHappenNext" error={errors.whatWillHappenNext}/>
										<Controller name="whatWillHappenNext" control={control}
											render={({ field: { value, onChange, ...field } }) => (
												<textarea {...field} rows="4" type="text" id="whatWillHappenNext" name="whatWillHappenNext" value={_states.whatWillHappenNext}
													className={`form-control ${errors.whatWillHappenNext ? 'is-invalid' : ''}`}
													aria-invalid={errors.whatWillHappenNext ? "true" : "false"}
													aria-describedby={errors.whatWillHappenNext ? "whatWillHappenNext-error" : ""}
													{...register('whatWillHappenNext')} onChange={(e) => {
														onChange(e.target.value);
														_storage.setWhatWillHappenNext(e.target.value);
														setStates({ ..._states, [e.target.name]: e.target.value });
													}}
												/>
											)}
										/>
										<p>You can enter up to 150 characters</p>
										<RemainingCharacters maxNoCharacters={150} inputValue={_states.whatWillHappenNext} />
									</div>


									<div className={errors.involvedOrganisationOrProfession ? 'form-group form-group--error' : 'form-group'}>
										<fieldset aria-describedby={errors.involvedOrganisationOrProfession ? "involvedOrganisationOrProfession-error" : ""}>
											<legend className="sr-only">Are other professionals/organisations involved?</legend>
											<FormControl>
												<label htmlFor="involvedOrganisationOrProfession" className="form-label">Are other professionals/organisations involved?*</label>
												<ErrorMessage id="involvedOrganisationOrProfession" error={errors.involvedOrganisationOrProfession}/>
												<RadioGroup {...register('involvedOrganisationOrProfession')} name="involvedOrganisationOrProfession" id="involvedOrganisationOrProfession" value={_states.involvedOrganisationOrProfession}
													onChange={(e) => {
														setStates({ ..._states, [e.target.name]: e.target.value })
														_storage.setInvolvedOrganisationOrProfession(e.target.value);
													}}
												>
													<FormControlLabel {...register('involvedOrganisationOrProfession')} value="yes" control={<Radio />} label="Yes" />
													<FormControlLabel {...register('involvedOrganisationOrProfession')} value="no" control={<Radio />} label="No" />
													<FormControlLabel {...register('involvedOrganisationOrProfession')} value="dontknow" control={<Radio />} label="Don't know" />
												</RadioGroup>
											</FormControl>

											{(_states.involvedOrganisationOrProfession === "yes") && (
												<div className="panel panel-border-narrow js-hidden">
													<label htmlFor="organisationDetails" className="form-label">If yes, please give details*</label>
													<ErrorMessage id="organisationDetails" error={errors.organisationDetails}/>
													<Controller name="organisationDetails" control={control}
														render={({ field: { value, onChange, ...field } }) => (
															<textarea {...field} rows="4" type="text" id="organisationDetails" name="organisationDetails" value={_states.organisationDetails}
																className={`form-control ${errors.organisationDetails ? 'is-invalid' : ''}`}
																aria-invalid={errors.organisationDetails ? "true" : "false"}
																aria-describedby={errors.organisationDetails ? "organisationDetails-error" : ""}
																{...register('organisationDetails')} onChange={(e) => {
																	onChange(e.target.value);
																	_storage.setOrganisationDetails(e.target.value);
																	setStates({ ..._states, [e.target.name]: e.target.value });
																}}
															/>
														)}
													/>
													<p>You can enter up to 150 characters</p>
													<RemainingCharacters maxNoCharacters={150} inputValue={_states.organisationDetails} />
												</div>
											)}
										</fieldset>
									</div>

									<UploadFiles formName="AscReferrals" utrn={_beginformStorage.getUtrn()} _storageGetFiles={_storage.getFiles} _storageSetFiles={_storage.setFiles}/>

									<div className="form-group form-group--progbuttons">
										<button className="btn  btn-light btn-lg" type="button"
											onClick={(event) => {
												event.preventDefault();
												navigate('/details');
											}}
										>Previous</button>
										<button className="btn btn-primary btn-lg" type="submit">Next</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</main>
		</Form>
	);
};
export default ReasonForReferral;
